// test66
(66 && 0);
